import {getReport, getLogImg, hasReportLogo, getReportType} from '@/api/form-render'
import webapp from '../../../sys/report/grwebapp.js'
import {getOrgCorpInfo} from '@/api/corp'
import utils from '../../../sys/report/utils.js'
export const mixin = {
  data: function () {
    return {
      formData: {},
      keyword: '',
      squareLogo: '',
      exportAll: false,
      optionsBtnType: {},
      advanceSearchBtnVisible: false,
      ImageList: [],
      selectMemberModels: {// 人员控件
        form: {},
        isShow: false,
        selectList: [],
        callBack: this.memberCallBack,
        radioSelectFlags: false
      },
      selectQuertersModels: {// 部门控件
        isShow: false,
        form: {},
        selectList: [],
        callBack: this.quertersCallBack,
        radioSelectFlags: false
      },
      html5Params: {},
      selectModalVisible: false,
      modalList: [],
      modal: {},
      selectFormVisible: false,
      selectFormQueryParams: null, // 选择弹框表单时查询传参
      selectFormConfig: {} // 选择弹出框的配置
    }
  },
  props: {
    searchFormColumns: {
      type: Array,
      default: function () {
        return []
      }
    },
    topButtons: {
      type: Array,
      default: function () {
        return []
      }
    },
    searchFormRows: { // 查询表单的行数据
      type: Array,
      default: function () {
        return []
      }
    },
    queryForm: { // 查询表单的行数据
      type: Object,
      default: function () {
        return {}
      }
    },
    title: { // 查询表单的行数据
      type: String,
      default: function () {
        return ''
      }
    },
    isTree: {
      type: Boolean,
      default: false
    },
    hasTitle: {
      type: Boolean,
      default: true
    },
    hasQuery: {
      type: Boolean,
      default: true
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    multipleSelect: { // 多选
      type: Boolean,
      default: false
    },
    searchVisible: { // 是否显示搜索框
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: '请输入关键字'
    },
    resetVisible: { // 是否显示重置按钮
      type: Boolean,
      default: false
    },
    queryBarVisible: { // 是否显示查询工具栏
      type: Boolean,
      default: true
    }
  },
  watch: {
    searchFormRows: {
      handler (newValue, oldValue) {
        this.searchFormRows.forEach(row => {
          row.forEach(column => {
            this.optionsBtnType[column.columnName + 'all'] = 'primary'
            if (column.sourceType) {
              this.optionsBtnType[column.columnName + 'all'] = 'default'
              for (const key in column.options) {
                let ele = column.columnName + key
                console.log(column.sourceType+"======ele=====",ele);
                if (column.sourceType == 'const' && key == column.sourceAttr) { // 判断是否是固定常量
                  this.$set(this.formData, column.columnName, key)
                  this.$set(this.optionsBtnType, ele, 'primary')
                  // console.log(this.formData)
                } else if (column.sourceType === 'sys-conf') { // 判断如果是系统常量
                  let attr = this.getConstValue(column.sourceAttr)
                  //console.log(key,"====attr=======",attr);
                  if (attr == key) {
                    this.$set(this.formData, column.columnName, key)
                    this.$set(this.optionsBtnType, ele, 'primary')
                  }else{
                    this.$set(this.optionsBtnType, ele, '')
                  }
                }else if (column.sourceType.startWith('current-')) { // 判断如果是系统常量
                  let attr = this.getConstValue(column.sourceType)
                  //console.log(key,"====attr==="+column.sourceType+"====",attr);
                  if (attr == key) {
                    this.$set(this.formData, column.columnName, key)
                    this.$set(this.optionsBtnType, ele, 'primary')
                  }else{
                    this.$set(this.optionsBtnType, ele, '')
                  }
                }else{
                  this.$set(this.optionsBtnType, ele, '')
                }
              }
            }else{
              // 如果参数不是固定的，而是从queryParams中传参
              if (column.matchType && column.row && column.col) {
                // console.log(column.columnName+'-------------',this.formData,this.formData[column.columnName],column)
                let val = this.formData[column.columnName]
                if(this.validUtil.isNotNull(val)){
                  this.optionsBtnType[column.columnName + 'all'] = 'default'
                  for (const key in column.options) {
                    // console.log(column.columnName+'-------' + val + '------',key)
                    if(val === key){
                      let ele = column.columnName + key
                      // this.$set(this.formData, column.columnName, key)
                      this.$set(this.optionsBtnType, ele, 'primary')
                    }
                  }
                }

              }
            }
          })
        })
      },
      immediate: true,
      deep: true
    }
  },
  created () {

  },
  mounted () {
    let _this = this
    _this.formData = Object.assign({}, _this.formData, this.queryForm)
    _this.selectFormConfig = {}
    _this.keyword = ''
    _this.advanceSearchBtnVisible = false
    // console.log('------mounted-----', _this.formData, this.queryForm)
    // this.searchFormRows = [];
    _this.init()
    // 获取是否携带公司logo
    hasReportLogo(this).then(res => {
      let hasLogo = res == '1'
      if (hasLogo) {
        getOrgCorpInfo(this.sessionUtil.getCompanyUid()).then(data => {
          this.squareLogo = data.squareLogo
        })
      }
    })
    // webapp.webapp_urlprotocol_startup()
  },
  methods: {
    init () {
      if (this.searchFormRows.length > 0) {
        // this.searchVisible = true;
        this.advanceSearchBtnVisible = true
        // 判断设置默认值
      }
    },
    // 清空输入
    handleClear (column) {
      this.$set(this.formData, column.columnName, undefined)
      this.$set(this.formData, column.columnName + 'LABEL_', undefined)
      this.$forceUpdate()
    },
    getConstValue (key) { // 根据key获取常量值
      // console.info(column)
      if (key === 'current-user-uid' || key === '当前用户主键') {
        return this.sessionUtil.getUserUid()
      } else if (key === 'current-user-id' || key === '当前用户编码') {
        return this.sessionUtil.getUserId()
      } else if (key === 'current-user-name' || key === '当前用户名称') {
        return this.sessionUtil.getUserName()
      } else if (key === 'current-depart-uid' || key === '当前部门主键') {
        return this.sessionUtil.getDepartUid()
      } else if (key === 'current-depart-id' || key === '当前部门编码') {
        return this.sessionUtil.getDepartId()
      } else if (key === 'current-depart-name' || key === '当前部门名称') {
        return this.sessionUtil.getDepartName()
      } else if (key === 'current-company-uid' || key === '当前组织主键') {
        return this.sessionUtil.getDepartUid()
      } else if (key === 'current-company-id' || key === '当前组织编码') {
        return this.sessionUtil.getDepartId()
      } else if (key === 'current-company-name' || key === '当前组织名称') {
        return this.sessionUtil.getDepartName()
      } else if (key === 'current-date' || key === '当前日期') {
        return (new Date()).format('yyyy-MM-dd')
        // mainData[column.columnName] = new Date()
      } else if (key === 'current-datetime' || key === '当前日期时间') {
        return new Date()
        // mainData[column.columnName] = (new Date()).format("yyyy-MM-dd hh:mm:ss")
      } else if (key === 'current-year' || key === '当前年' || key === '本月') {
        return new Date().getFullYear()
      } else if (key === 'current-month' || key === '当前月' || key === '本月') {
        return new Date().getMonth() + 1
      } else if (key === 'current-month-long') {
        let s = new Date().getMonth() + 1;
        return this.util.numPadStart(s,2);
      }else if (key === 'current-week' || key === '当前周' || key === '本周') {
        return this.util.getYearWeek()
      } else if (key === 'current-next-monday' || key === '下周一') { // 下周一
        return this.util.getNextMonday()
      } else if (key === 'current-month-first' || key === '本月第一天') { // 本月第一天
        return this.util.getCurrentMonthFirst()
      } else if (key === 'current-month-last' || key === '本月最后一天') { // 本月最后一天
        return this.util.getCurrentMonthLast()
      } else if (key === 'next-month-first' || key === '下月第一天') { // 下月第一天
        return this.util.getNextMonthFirst()
      } else if (key === 'next-month-last' || key === '下月最后一天') { // 下月最后一天
        return this.util.getNextMonthLast()
      } else {
        let sessionProj = null
        if (window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id)) {
          sessionProj = JSON.parse(window.localStorage.getItem('_session_proj' + this.sessionUtil.getUser().id))
        } else if (this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id]) {
          sessionProj = this.getFormConfig['_session_proj' + this.sessionUtil.getUser().id].data
          // console.log('------mainData-------', mainData, sessionProj)
        }
        if (sessionProj) {
          sessionProj = {
            'session-proj-code': sessionProj.PROJ_CODE_,
            'session-proj-id': sessionProj.PROJ_ID_,
            'session-proj-name': sessionProj.PROJ_NAME_,
            'session-proj-uid': sessionProj.PROJ_UID_
          }
          for (const edit in sessionProj) {
            if (key.indexOf(edit) > -1) {
              key = key.replace(new RegExp('{' + edit + '}', 'gm'), sessionProj[edit])
            }
          }
        }
        // 如果是占位符且没有匹配到参数
        if (key.indexOf('{') > -1) {
          return ''
        }
        return key
      }
    },
    openForm (column) { // 点击新增
      this.$emit('openForm', column)
    },
    handlerAdvanceBtnClick () {
      this.advanceSearchVisible = !this.advanceSearchVisible
      this.queryData(0)
      // this.$forceUpdate()
    },
    handlerTopButtonClick (column) {
      console.log('-----handlerTopButtonClick-----',column)
      // 判断是否自定义按钮
      if (column.openType && column.openUrl) {
        if (column.openType === 2) { // 打开标签页
          this.openByName(column.openUrl, column.openParams)
        } else if (column.openType === 1) { // 弹框打开
          this.$emit('handlerTopButtonClick', column)
        }  else if (column.openType === 3) {
          if(column.openUrl.indexOf("http") != -1){
            window.open(column.openUrl,'_blank');
          } else {
            const newurl = this.$router.resolve({name: column.openUrl, params: JSON.parse(column.openParams)})
            window.open(newurl.href,'_blank');
          }
        } else {
          if(column.openUrl.indexOf("http") != -1){
            window.open(column.openUrl,'_self');
          } else {
            this.$router.push({name: column.openUrl, params: JSON.parse(column.openParams)})
          }
        }
      } else {
        // 标准按钮新增
        if (column.columnName === 'new') {
          this.openForm()
        } else if (column.columnName === 'new-child') {
          this.openForm(column)
        } else if (column.columnName === 'edit') {
          this.$emit('handlerTopButtonClick', column)
        } else if (column.columnName === 'delete') {
          this.$emit('handlerTopButtonClick', column)
        }
        // 导入
        else if (column.columnName === 'import') {

        }
        // 导出
        else if (column.columnName === 'export') {
          if (this.sessionUtil.isCloud() && !this.sessionUtil.isProVersion()) {
            this.$bus.emit('on-show-license-msg', 4)
            return false
          }
          let formConfig = this.$parent.formConfig
          let param = {
            'type': '1',
            'formInfoId': formConfig.id
          }
          // Object.assign(gridData, this.$parent.gridData)
          // console.log('-------1-------',this.$parent.gridData, formConfig)
          // return
          let logoParams = {
            id: this.squareLogo
          }
          // 获取logo
          getLogImg(logoParams).then(res2 => {
            let gridData = JSON.parse(JSON.stringify(this.$parent.gridData))
            let data = {'Table': [], 'Detail1': this.filterData(gridData, formConfig)}
            if (res2) {
              data.Table = [{'SYS_COMPANY_LOGO': res2}]
            }
            // console.log('-------2-------',this.$parent.gridData,gridData)
            this.html5Params = {
              formConfig: formConfig,
              data: data,
              type: '1',
              formId: formConfig.formId,
              formInfoId: formConfig.id
            }
          })
          this.exportAll = false
          if (column.attr) {
            try {
              let data = JSON.parse(column.attr)
              this.exportAll = data.exportAll == 1
            } catch (error) {
              this.exportAll = false
            }
          }
          setTimeout(() => {
            getReport(param, this).then(data => {
              if (data) {
              // 如果有多个模板
                if (data.length > 1) {
                  let sysList = data.filter(item => {
                    return item.category !== 1
                  })
                  let userList = data.filter(item => {
                    return item.category === 1
                  })
                  if (userList && userList.length > 0) {
                    this.modalList = userList
                  } else {
                    this.modalList = sysList
                  }

                  this.selectModalVisible = true
                } else {
                  this.html5Params.grf = data[0].grf
                  this.openReport()
                }
              } else {
                this.html5Params.grf = JSON.stringify(utils.getReport(formConfig, 1, null, null))
                this.openReport()
              }
            })
          }, 1000)
        } else {
          this.$emit('handlerTopButtonClick', column)
        }
      }
    },
    openSelectForm (column) { // 打开树表选择框
      // console.info('------openSelectForm------1--')
      this.selectFormKey = column.attr
      this.formSelectBindColumn = column
      this.selectFormVisible = true
    },
    confirmSelect () { // 弹框选择确定数据
      let selectedData = []
      let selectForm = this.$refs['select-form']
      if (selectForm && selectForm.getSelectedData) {
        // console.info('---------------------'+selectForm.getSelectedData)
        selectedData = selectForm.getSelectedData()
      }
      if (selectedData.length === 0) {
        this.util.warn('请选择数据')
        return
      }
      // 表示单选
      let selectedRow = selectedData[0]
      if (this.formSelectBindColumn != null) {
        this.formData[this.formSelectBindColumn.columnName] = selectedRow[this.formSelectBindColumn.columnName]
        this.formData[this.formSelectBindColumn.columnName + 'LABEL_'] = selectedRow[this.formSelectBindColumn.columnName + 'LABEL_']
      }
      this.selectFormVisible = false
      this.formSelectBindColumn = null
    },
    setFormWidth (formConfig) {
      this.selectFormConfig = formConfig
    },
    openReport () {
      // 免费版无法导出
      setTimeout(() => {
      // 由于需要加载流程图片信息 需要延时加载
        if (this.ImageList && this.html5Params.grf) {
          this.html5Params.grf = JSON.parse(this.html5Params.grf)
          this.html5Params.grf.ImageList = this.ImageList
          this.html5Params.grf = JSON.stringify(this.html5Params.grf)
        }
        // console.log(this.sessionUtil.isCloud()+'------------------'+this.sessionUtil.isProVersion())
        if (this.sessionUtil.isCloud() && !this.sessionUtil.isProVersion()) {
          this.$bus.emit('on-show-license-msg', 4)
          return false
        }
        // console.log('------------------')

        getReportType(this).then(res => {
        // 0为服务端 1为客户端
          if (res.data == '1') {
          // 直接启动报表客户端打印
            if (this.html5Params.grf && this.html5Params.data) {
              webapp.webapp_urlprotocol_startup()
              // console.log('------openReport-------')
              setTimeout(() => {
              // console.log('-------111--------',this.html5Params.grf)
                let grfJson = webapp.webapp_register(this.html5Params.grf)
                // console.log('-------222--------',grfJson)
                let content = '_WR_w[kPLVK/4w[KKPL[/{%4wV{[HLPP{4w`/[`LV{V{4w`Kk[L/P`4w[K[L[%[%4w[H{HLVk{[4w[k%L`{`4wP%KL[[/V4w/`HL/H{[4w/{%KLVkk4w/[HHL/KkK4w[Vk/L/`{4wV`/`LV[KK4w[kPVL/k%P4w`k`KLV%%V4wPkHL[{``4w`{%`L/KKk4w//PHL`[PV4w``KVL`V{K4wP[PL`/k`4w`{VPLV{%`4w`/`KLHH{4w[P%kL`k`P4w[%H{L/{V[4w[{{L{`{4wV/%[LVk%V4rdC8n%ZHZkZ[<2Yn`F^OPF%P\\Pg`F%V&8?OPPA\\g%Jj%g`\'j(g%t&V\\Kj&^%VC?}uPPPp?K?V`KVC/V}PkOy%K(tFO`C$Kg%AK&\'Ktj%P{O/#O%<m1nKNZ自由表格<^n锐浪报表软件<N\'n用自V9格部件编制自由表格。<8M@VoCgn宋体<D1h/kPkkk5q8hVkk5ah/`VQ5}\'n^ MU+qT Bu+e M]MfCgXT:Z,F1YOZVZkW| |@J]T -yYB\'ql+@W| |@YN:N-&MI eTBZZ||YN:N||}M :b~+@qZlqD<>Yn]TcTe:Is-f Ml-1lxcM*TT]| |@~bT T-1lxcM*TTyYBP<^ +@:T o:Oh/5Y8hkZP5EYh/5lhkZPQ5^N NlT:T hwrdCgng,&p9.CZn&}9.Cgn^=,X9}\'uT9.Cgn&JOX1gp9.Cgn&JO9g,u^\'}C9.Cgn&p\'=p9Y\'p19.Cgn1}Y9Y\'p19.Cgn(O8&9.Cgn8O8&9.Cgn((C?9.Cgn(C:?9.Cgn8yF19.Cgn 采合约部.Cgn招采合约部T@qpTlT.Cgn项目工程管理部.Cgn项目工程管理部T@qp+lT.:gn总工办.Cgn总M办T@qp+lT.Cgn成本管理部.Cgn成本管理部T@qp+lT.Cgn投委会主任.Cgn投委会主任T@qp+lT.Cgng=1\'p19J&1=9.Cgng=1\'p19pyu19.Cgng,}p1}p9dQ45=TxM :$TNqT hwrdCgn=TxM :$TNqT [<(Oh[VZP5gM@: MchwrdF8n&:N:+eOMm<Cgn&:N:+eOMm/<In$M +aM@:Nc<]Oh%Zk{PV[[g8hkZ[//%%H5T8h%ZHKKHK5(OhkZHK`HP58M@:oCgn宋体<D1h/{kkkk5fh: -T5ah/`VQ5 1n招标计划申请及审批表.F8n8 TTt +q<Cgn8 TTt +q/<]OhkZ/P{HP5g8h/ZK{V`{5OM qT ol1nwY N~FTf:7Y N~pMx7Y N~=+>b:7Y N~OM::Ml4<^T@oT8h[QQ5X\'hV5]Yh/[58 TTt +qgMcIl@hwrd+@qTmh/5T8h[ZK%```_+@qTmh[5T8hPZ{[k{`_+@qTmh`5T8h[Z{_+@qTmhV5T8h%Z?[%[PQ458 TTt +q=M~hwrd+@qTmh/5(Oh/_+@qTmh[5(OhkZKH{KP{_+@qTmh`5(OhkZKH{KP{_+@qTmhV5(OhkZKH{KP{_+@qTmhP5(Oh/_+@qTmh%5(Oh/_+@qTmhH5(Oh`Z[k/V%_+@qTmh{5(Oh[ZV{Hk{_+@qTmhK5(Oh[ZV%k%`_+@qTmh/k5(Oh[Z%VP{`_+@qTmh//5(Oh[QV%k%`_+@qTmh/[5(Oh[ZK%```Q458 TTt +qgTcchwrd M~h/5eMch/5]1nu+qqcTgT@:T < 1n工程项目名称. M~h/5eMch[5f8h: IT5 1nw00r^=,X9}\'u19Q004. M~h/5eMch`5]1nu+qqcTgT@:T < 1n招标工程名称. M~h/5eMchV5f8h: IT5Eh: IT5 1nw00r&JOX1gp9Q004. M~h[5eMch/5]1nu+qqcTgT@:T < 1n概（预）算（万元）. M~h[5eMch[5 1nw00rg,&p9Q004<t\'h`_ M~h`5eMch/5]1nu+qqcTgT@:T < 1n申请部门. M~h`5eMch[5 1nw00r&JO9g,u^\'}C9Q004. M~h`5eMch`5]1nu+qqcTgT@:T < 1n申请人. M~h`5eMchV5 1nw00rg=1\'p19J&1=9Q004. M~hV5eMch/5]1nu+qqcTgT@:T < 1n计划入场日期. M~hV5eMch[5 1nw00r&p\'=p9Y\'p19Q004. M~h由5eMch`5]1nu+qqcTgT@:T < 1n计划竣工日期. M~hV5eMchV5 1nw00r1}Y9Y\'ph9Q004. M~hP5eMch/5]1nu+qqc1gT@:T < 1n招标方式. M~hP5eMch[5 1nw00r(O8&9Z004. M~hP5eMch`5]1nu+qqcTgT@:T < 1n发包方式. M~hP5eMchV5f8h: IT5Eh: IT5 1nw00r8O8&9Qu04. M~h%5eMch/5]1nu+qqcTgT@:T < 1n资质等级要求. M~h%5eMch[5 1nw00r((C{9Q004. M~h%5eMch`5]1nu+qqcTgT@:T < 1n专业技能要求. M~h%5eMchV5 1nw00r(CC?9Q004. M~hH5eMch/5]1nu+qqcTgT@:T < 1n招标内容. M~hH5eMch[5\'Oh: IT5gM : MchwrdF8nuTlMOMm<CgnuTlMO工mH<]Oh`Z/HP5g8h/kZK{k[5T8h/ZVk[[K5(Oh/ZkkPV[5Eh: IT5f8h: IT5]1nOM::MlgT@:T < 1n附件：.F8nuTlMOMm<CgnuTlMOMm{<]OhVZPHH[K5g8h/kZK{k[5T8h/`Zk/HP5(Oh/ZkkPV[5Eh: IT5f8h: IT5]1npMxFTf:< 1nw008yF1表004.F8nuTlMOMm<CgnuTlMOMmK<]Oh`Z/HP5g8hHZKKkV[5T8h/VZV/K{5(Oh[ZK{KHK5Eh: IT5f8h: IT5]1npMxFTf:< 1nw00g,}p1}p9004dQ45t\'h`_ M~h{5eMch/5 1n招采合约部负责人| |@审核意见. M~h{neMch[5]1npMxFTf:< 1nw00招采合约部004------<t\'h`_ M~hK5eMch/5 1n总工办负责人| |@审核意见. M~hK5eMch[5]1npMxFTf:< 1nw00总工办004<t\'h`_ M~1/k5eMch/5 1n项目工程管理部负责人| |@审核意见. M~h/k5eMch[5]1npMxFTf:< 1nw00项目工程管理部004<t\'h`_ M~h//5eMch/5 1n成本管理部负责人| |@审核意n. M~h//5eMch[5]1npMxFTf:< 1nw00成本管理部004<t\'h`_招M~h/[5eMch/5f8h: IT5 1n投委会主任或其授权人意见. M~h/[5eMch[5]1npMxFTf:< 1nw00投委会主任004<t\'h`Q4_F8nuTlMOMm<CgnuTlMOMmP<]Oh/[Z{kP{5g8h/Z/Kk%`5T8h/ZVk[[K5(OhkZ{[k[k{5Eh: IT5f8h:@IT5]1nu+qqcTgT@:T < 1n编号v.F8nuTlMOMm<Cg5uTl-OMm%<]Oh/VZ[k{/5g8h/Z/Kk%`5T8hVZV/{PV5(OhkZ{[k[k{5Eh: IT5f8h: I+5 1nw00&}9004.F8nuT|MOMm<CgnuTlMOMm5<]Oh/ZkkPV[5g8h/Z/Kk%`5T8h/ZK{V`{5(OhkZ{[k[k{5Eh: IT5f8h: IT5]1nu+qqcTgT@:T < 1n申请日期：.F8nuTlMOMm<CgnuTlMOMmV<]Oh[ZK{KHK5g8h/Z/Kk%`5T8h`ZKKP[/5(OhkZ{[k[k{5Eh: IT5f8h: IT5 1nw00g=1\'p19pyu19004.F8nuTlMOMm<CgnuTlMOMm/k<]Oh`Z[k/V%5g8hHZKKkV[5T8h/VZV/K{5(Oh[Z[8[P5Eh: IT5f8h: IT5]1npMxFTf:< 1nw00g,}p1}p9004.F8nuTlMOMm<CgnuTlMOMm//<]Oh`Z[k/V%5g8h/kZ[/[K5T[h/ZVk[[K5(OhkZHK`HP5Eh: IT5f8h: IT5]1nOM::MlgT@:T < 1n附件：.F8nuTlMOMm<CgnuTlMOMm/[<]OhVZ%k`HP5g8h/kZ[/[K5T8h/`Zk/HP5(Oh/ZkkPV[5Eh: IT5f8h: IT5 1nw008yF19004.F8nuTlMOMm<CgnuTlMOMm/V<]OhKZ`K[H/5g8h/[Z%VH/5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlgT@:T < 1n签署v.F8nuTlMOMm<CgnuTlMOMm/P<]Oh/`ZKV`P5g8h/[Z%VH/5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MIgT@:T < 1n时间v.F8n0TlMOMm<CgnuTlMOMm/%<]Oh/PZ/`V[5g8h/[Z%:H/5T8h`ZV/`/`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlFTf:< 1nw00招采合约部T@qp+lT004.F8nuTlMOMm<CgnuTlMOMm/{<]OhKZ`K[H/5g8h/PZ/kHH5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT5f8h: IT551nOM::MlgT@:T < 1见签署v.F8nuTlMOMm<CgnuTlMOMm[k<]Oh/`ZKK%P5g8h/PZ/kHH5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT]f8h: IT5]1nOM::MlgT@:T < 1n时间v.F8nuTlMOMm<CgnuTlMOMm[/<]Oh/PZ/{H/5g8h/PZ/kHH5T8h`ZV/`/`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlFTf:< 1nw00总8办T@qp+lT004.F工n^+e:I TOMm<Cgn^+e:I TOMm[`<]Oh/kZP{``5g8h/PZ/kHH5T8h`Zk/%[P5(Oh/ZkkPV[5#\'nUN -t Nxb+e]-B-=TxM :Zt Nxb+e]L| |@----m-B-t Nxb+e]ZFTf:L| |@----*-B-t Nxb+e]ZpMxL| |@----~+q:b-B-t Nxb+e]Z\\+q:bL| |@----bT+>b:-B-t Nxb+e]Z$T+>b:L| |@| |@----x+e-B-=TxM :ZJ:+c+:*Zg TN:T^+e:I TiGL-;;创建图像对象| |@----O+@N *-B-=TxM :ZJ:+c+:*Zg TN:TO+@N *,DzTe:iGL| |@----| |@| |@--M-O+@N *ZFMNq8 Ml8+Tcqi-=TxM :Z8+TcqO*}NlTi|d招采合约部]+>@|dG-GW-;;从字段中载入图像| |@----x+eZFMNq8 MlO+@N *iO+@N *GW-;;载入图像| |@----=TxM :Zt Nxb+e]ZY N~^+e:I Tix+eL-mL-*L-~+qCbL-bT+>b:L-`L-[L-/GWl |@<e1n1@]I T8lcc#+T~<TOh`_F8nuTlMOMm<CgnuTlMOMm[[<]OhKZ`%%[P5g8h/HZHP`P5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlgT@:T < 1n签署v.F8nuTlMOMm<CgnuTlMOMm[`<]Oh/`ZKH5g8h/HZHP`P5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlgT@:T < 1n时间v.F8nuTlMOMm<CgnuTlMOMm[V<]Oh/PZ/%k%5g8h/HZHP`P5T8h`ZV/`/`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlFTf:< 1nw00项目工程管理部T@qp+lT004.F8n^+e:I TOMm<Cgn^+e:I TOMm[V<]Oh/kZPP%K5g8h/HZHP`P5T8h`Zk/%[P5(Oh/ZkkPV[5#\'nUN -t Nxb+e]-B-=TxM :Zt Nxb+e]L| |@----m-B-t Nxb+e]ZFTf:L| |@----*-B-t Nxb+e]ZpMxL| |@----~+q:b-B-t Nxb+e]Z\\+q:bL| |@----bT+>b:-B-t Nxb+e]Z$T+>b:L| |@| |@----x+e-B-=TxM :ZJ:+c+:*Zg TN:T^+e:I TiGL-;;创建图像对象| |@----O+@N *-B-=TxM :ZJ:+c+:*Zg TN:TO+@N *,DzTe:iGL| |@----| |@| |@----O+@N *ZFMNq8 Ml8+Tcqi-=TxM :Z8+TcqO*}NlTi|d招采合约部]+>@|dG-GW-;;从字段中载入图像| |@----x+eZFMNq8 MlO+@N *iO+@N *GW-;;载入图像| |@----=TxM :Zt Nxb+e]ZY N~^+e:I Tix+eL-mL-*L-~+q:bL-bT+>b:L-`L-[L-/GW| |@<e1n1@]I T8Icc#+T~<TOhV_F8nuTlMOMm<CgnuTlMOMm[P<]OhKZ`%%[P5g8h[kZ[/V[5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlgT@:T < 1n签署v.F8nuTlMOMm<CgnuTlMOMm[%<]Oh/`ZKH5g8h[kZ[/V[5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlgT@:T < 1n时间v.F8nuTlMOMm<CgnuTlMOMm[H<]Oh/PZ/%k%5g8h[kZ[/V[5T8h`ZV/`/`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlFTf:< 1nw00成本管理部T@qp+lT004.F8n^+e:I TOMm<Cgn^+e:I TOMm[P<]Oh/kZPP%K5g8h[kZ[/V[5T8h`Zk/%[P5(Oh/ZkkPV[5#\'nUN -t Nxb+e]-B-=TxM :Zt Nxb+e]L| |@----m-B-t Nxb+e]ZFTf:L| |@----*-B-t Nxb+e]ZpMxL| |@----~+q:b-B-t Nxb+e]Z\\+q:bL| |@----bT+>b:-B-t Nxb+e]Z$T+>b:L| |@| |@----x+e-B-=TxM :ZJ:+c+:*Zg TN:T^+e:I TiGL-;;创建图像对象| |@----O+@N *-B-=TxM :ZJ:+c+:*Zg TN:TO+@N *,DzTe:iGL| |@----| |@| |@----O+@N *ZFMNq8 Ml8+Tcqi-=TxM :Z8+TcqO*}NlTi|d招采合约部]+>@|dG-GW-;;从字段中载入图像| |@----x+eZFMNq8 MlO+@N *iO+@N *GW-;;载入图像| |@----=TxM :Zt Nxb+e]ZY N~^+e:I Tix+eL-mL-*L-~+q:bL-bT+>b:L-`L-[L-/GW| |@<e1n1@]I T8Icc#+T~<TOhP_F8nuTlMOMm<CgnuTlMOMm[{<]OhKZ`K[H/5g8h[`Z/HHP5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlgT@:T < 1n签署v.F8nuTlMOMm<CgnuTlMOMm[K<]Oh/`ZKK%P5g8h[`Z/HHP5T8h/Z/Kk%`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlgT@:T < 1n时间v.F8nuTlMOMm<CgnuTlMOMm`k<]Oh/PZ/{H/5g8h[`Z/HHP5T8h`ZV/`/`5(OhkZKH{KP{5Eh: IT5f8h: IT5]1nOM::MlFTf:< 1nw00投委会主任T@qp+lT004.F8n^+e:I TOMm<Cgn^+e:I TOMm[%<]Oh/kZP{``5g8h[`Z/HHP5T8h`Zk/%[P5(Oh/ZkkPV[5#\'nUN -t Nxb+e]-B-=TxM :Zt Nxb+e]L| |@----m-B-t Nxb+e]ZFTf:L| |@----*-B-t Nxb+e]ZpMxL| |@----~+q:b-B-t Nxb+e]Z\\+q:bL| |@----bT+>b:-B-t Nxb+e]Z$T+>b:L| |@| |@----x+e-B-=TxM :ZJ:+c+:*Zg TN:T^+e:I TiGL-;;创建图像对象| |@----O+@N *-B-=TxM :ZJ:+c+:*Zg TN:TO+@N *,DzTe:iGL| |@----| |@| |@----O+@N *ZFMNq8 Ml8+Tcqi-=TxM :Z8+TcqO*}NlTi|d招采合约部]+>@|dG-GW-;;从字段中载入图像| |@----x+eZFMNq8 MlO+@N *iO+@N *GW-;;载入图像| |@----=TxM :Zt Nxb+e]ZY N~^+e:I Tix+eL-mL-*L-~+q:bL-bT+>b:L-`L-[L-/GW| |@<e1n1@]I T8Icc#+T~<TOh%_F8n^+e:I TOMm<Cgn^+e:I TOMm[H<]Oh/kZ%kK{5g8h/[ZPKV[5T8h`Zk/%[P5(Oh/ZkkPV[5#\'nUN -t Nxb+e]-B-=TxM :Zt Nxb+e]L| |@----m-B-t Nxb+e]ZFTf:L| |@----*-B-t Nxb+e]ZpMxL| |@----~+q:b-B-t Nxb+e]Z\\+q:bL| |@----bT+>b:-B-t Nxb+e]Z$T+>b:L| |@| |@----x+e-B-=TxM :ZJ:+c+:*Zg TN:T^+e:I TiGL-;;创建图像对象| |@----O+@N *-B-=TxM :ZJ:+c+:*Zg TN:TO+@N *,DzTe:iGL| |@----| |@| |@----O+@N *ZFMNq8 Ml8+Tcqi-=TxM :Z8+TcqO*}NlTi|d招采合约部]+>@|dG-GW-;;从字段中载入图像| |@----x+eZFMNq8 MlO+@N *iO+@N *GW-;;载入图像| |@----=TxM :Zt Nxb+e]ZY N~^+e:I Tix+eL-mL-*L-~+q:bL-bT+>b:L-`L-[L-/GW| |@<e1n1@]I T8Icc#+T~<TOh[Q4Q4Q'
                webapp.webapp_ws_run({}, grfJson, JSON.stringify(this.html5Params.data))
              // webapp.webapp_ws_run({}, content, JSON.stringify(this.html5Params.data))
              }, 100)
            }
          } else {
          // html5+报表服务端打印
            this.$emit('openReport', {
              grf: this.html5Params.grf,
              data: this.html5Params.data,
              fileName: this.title,
              isForm: false,
              exportAll: this.exportAll
            })
          // this.$router.push({
          //   name: 'page-html5',
          //   params: {
          //     grf: this.html5Params.grf,
          //     data: this.html5Params.data,
          //     fileName: this.title
          //   }
          // })
          }
        })
      }, 500)
    },
    selectModal () {
      this.modalList.forEach(edit => {
        if (edit.selected === true) {
          this.$set(this.html5Params, 'grf', edit.grf)
        }
      })
      this.openReport()
    },
    // 过滤数据
    filterData (data, formConfig) {
      if (!data || !formConfig) return
      data.forEach(item => {
        formConfig.queryColumns.forEach(e => {
          if (item[e.columnName + 'LABEL_']) {
            item[e.columnName] = item[e.columnName + 'LABEL_']
          }
          // 如果字段是"CREATE_USER_"那么 值一定为 CREATE_USER_LABEL_
          if (e.columnName === 'CREATE_USER_') {
            item[e.columnName] = item[e.columnName + 'LABEL_']
          }
          // 如果是人员选择 那么字段是ID_值一定为 LABEL_
          if (e.widgetType === 'select-user' && (e.columnName.lastIndexOf('UID_') > -1 || e.columnName.lastIndexOf('ID_') > -1)) {
            item[e.columnName] = item[e.columnName + 'LABEL_']
          }
          // 如果是时间控件
          if (e.widgetType === 'select-date' || e.widgetType === 'select-time' || e.widgetType === 'select-date-time') {
            let format = 'yyyy-MM-dd'
            if (e.widgetType === 'select-time') {
              format = 'HH:mm:ss'
            } else if (e.widgetType === 'select-date-time') {
              format = 'yyyy-MM-dd hh:mm:ss'
            }
            item[e.columnName] = this.formatDate(format, item[e.columnName])
          }
          if (e.widgetType === 'select-dic' || e.widgetType === 'select-sql' || e.widgetType === 'select') {
            if (e.options) {
              if (e.options[item[e.columnName]]) {
                item[e.columnName] = e.options[item[e.columnName]]
              } else {
                for (const key in e.options) {
                  // 如果key值有空值 那么默认赋值给item[e.columnName]
                  if (!key) {
                    item[e.columnName] = e.options[key]
                  }
                }
              }
            }
          }
          // 如果是switch控件 判断是否选中 默认1为是 0 为否
          if (e.widgetType === 'switch') {
            let activeValue = (e.options && e.options[1] !== undefined) ? e.options[1] : '是'
            let inActiveValue = (e.options && e.options[0] !== undefined) ? e.options[0] : '否'
            item[e.columnName] = (item[e.columnName + '_SWITCH'] == 'true') ? activeValue : inActiveValue
          }
        })
      })
      return data
    },
    formatDate (format, value) {
      if (typeof value === 'number') {
        let date = new Date(value)
        return date.format(format)
      } else if (typeof value === 'string') {
        if (value.indexOf('T') > -1) {
          return value.substring(0, 10)
        } else {
          try {
            if (value.indexOf(':') > -1 || value.indexOf('-')) {
              return value
            } else {
              let num = Number(value)
              let date = new Date(num)
              return date.format(format)
            }
          } catch (e) {
            return value
          }
        }
      } else if (typeof value === 'object') {
        return value.format(format)
      }
    },
    selected (item, list) {
      // 由于单选
      for (var i = 0; i < list.length; i++) {
        // 默认第一个选中
        var temp = list[i]
        // console.info(temp.id +'=='+ item.id)
        if (temp.id == item.id) {
          temp.selected = true
        } else {
          temp.selected = false
        }
      }
      this.$forceUpdate()
    },
    handlerClickAll (column) {
      let columnName = column.columnName
      let eidt = columnName + 'all'
      this.optionsBtnType[eidt] = 'primary'
      this.formData[column.columnName] = null
      for (const key in column.options) {
        let ele = columnName + key
        this.optionsBtnType[ele] = ''
      }
      this.$forceUpdate()
      this.queryData()
    },
    handlerSearchBtnClick (column, index) {
      // console.log('----handlerSearchBtnClick-----',index)
      let columnName = column.columnName
      this.optionsBtnType[columnName + 'all'] = 'default'
      let eidt = columnName + index
      if(column.optionsArr){
        eidt = columnName+column.optionsArr[index].value;
      }
      //console.log(index+'====eidt=====',eidt,this.optionsBtnType[eidt])
      this.optionsBtnType[eidt] = this.optionsBtnType[eidt] === 'primary' ? '' : 'primary'

      // 获取选择值
      this.formData[columnName] = ''
      // 兼容下拉框是数组不是对象，如果是对象index是对象的key
      if(column.optionsArr){
        column.optionsArr.forEach((item,key)=>{
          let ele = columnName + item.value;
          if (ele !== eidt) {
            this.optionsBtnType[ele] = ''
          }
          if (this.optionsBtnType[ele] === 'primary') {
            // this.formData[columnName] += "'" + key + "',"
            this.formData[columnName] += item.value
          }
        });
      }else{
        for (const key in column.options) {
          let ele = columnName + key
          if (ele !== eidt) {
            this.optionsBtnType[ele] = ''
          }
          if (this.optionsBtnType[ele] === 'primary') {
            // this.formData[columnName] += "'" + key + "',"
            this.formData[columnName] += key
          }
        }
      }

      // this.formData[columnName] = this.formData[columnName].substring(0, this.formData[columnName].length - 1)
      this.$forceUpdate()
      this.queryData()
    },
    handlerValueChange (column, value) { // 主表数据change时触发
      // console.info(column.columnName + '------handlerValueChange------' + value)
      // 先判断数据来源绑定主表字段的情况
      if (this.sourceData) {
        for (let key in this.sourceData) {
          let sourceColumnName = this.sourceData[key]
          // 判断是否当前列的数据触发影响其他列
          if (sourceColumnName === column.columnName) {
            let column = this.formColumnsMap[key]
            // 判断是否中文字段
            if (column.widgetType === 'number-cn' && value != undefined) {
              let newValue = this.util.numToCn(value)
              this.formData[key] = newValue
            }
          }
        }
      }
      // 判断如果是switch组件需要特殊处理
      if (column.widgetType === 'switch') {
        this.formData[column.columnName] = value ? 1 : 0
        this.formData[column.columnName] += ''
        this.formData[column.columnName + '_SWITCH'] = value
        this.$forceUpdate()
      }
      // 判断如果是时间区间查询组件需要特殊处理
      if (column.widgetType === 'select-date') {
        let format = 'yyyy-MM-dd'
        if (column.widgetType === 'select-time') {
          format = 'HH:mm:ss'
        } else if (column.dateType === 'datetimerange') {
          format = 'yyyy-MM-dd hh:mm:ss'
        } else if (column.dateType === 'monthrange') {
          format = 'yyyy-MM'
        }
        if (column.dateType === 'datetimerange' || column.dateType === 'daterange' || column.dateType === 'monthrange') {
          let str = ''
          if (value && value.length > 0) {
            for (let index = 0; index < value.length; index++) {
              if (index != 0) {
                str += ','
              }
              str += this.formatDate(format, value[index])
            }
          }
          this.formData[column.columnName] = str
        } else {
          this.formData[column.columnName] = this.formatDate(format, value)
        }
        this.$forceUpdate()
      }
    },
    // 选人点击事件
    selectMember (column) {
      this.selectMemberModels.isShow = true
      this.selectMemberModels.form = column
      this.selectMemberModels.radioSelectFlags = (column.widgetType === 'select-user')
    },
    // 选人回调函数
    memberCallBack () {
      this.selectMemberModels.isShow = false
      var vm = this
      this.searchFormRows.forEach(element => {
        element.forEach(e => {
          if (e.columnName === this.selectMemberModels.form.columnName) {
            if (this.selectMemberModels.form.widgetType === 'select-user') {
              if (this.selectMemberModels.selectList.length > 0) {
                vm.$set(vm.formData, e.columnName + 'LABEL_', this.selectMemberModels.selectList[0].userName)
                vm.$set(vm.formData, e.columnName, this.selectMemberModels.selectList[0].id)
                if (e.columnName.lastIndexOf('UID_') > -1) {
                  let name = e.columnName.split('UID_')
                  vm.$set(vm.formData, name[0] + 'NAME_', this.selectMemberModels.selectList[0].userName)
                }
                if (e.columnName.lastIndexOf('ID_') > -1) {
                  let name = e.columnName.split('ID_')
                  vm.$set(vm.formData, name[0] + 'NAME_', this.selectMemberModels.selectList[0].userName)
                }
              } else {
                vm.$set(vm.formData, e.columnName + 'LABEL_', '')
                vm.$set(vm.formData, e.columnName, '')
              }
            } else if (this.selectMemberModels.form.widgetType === 'select-user-multi') {
              // eslint-disable-next-line no-unused-vars
              var labels = ''; var ids = ''
              this.selectMemberModels.selectList.forEach(element => {
                labels += element.userName + ','
                ids += element.id + ','
              })
              vm.$set(vm.formData, e.columnName + 'LABEL_', labels.substring(0, labels.length - 1))
              vm.$set(vm.formData, e.columnName, ids.substring(0, ids.length - 1))
              // 判断字段是否为ID_或UID_结尾 是则给NAME_也赋值
              if (e.columnName.lastIndexOf('UID_') > -1) {
                let name = e.columnName.split('UID_')
                vm.$set(vm.formData, name[0] + 'NAME_', labels.substring(0, labels.length - 1))
              }
              if (e.columnName.lastIndexOf('ID_') > -1) {
                let name = e.columnName.split('ID_')
                vm.$set(vm.formData, name[0] + 'NAME_', labels.substring(0, labels.length - 1))
              }
            }
          }
        })
      })
    },
    // 选部门点击事件
    selectQuerters (column) {
      this.selectQuertersModels.isShow = true
      this.selectQuertersModels.form = form
      this.selectQuertersModels.radioSelectFlags = (form.widgetType === 'select-depart')
    },
    // 选部门回调函数
    quertersCallBack () {
      this.selectQuerters.isShow = false
      var vm = this
      this.searchFormRows.forEach(element => {
        element.forEach(e => {
          if (e.columnName === this.selectQuertersModels.form.columnName) {
            if (this.selectQuertersModels.form.widgetType === 'select-depart') {
              vm.$set(vm.formData, e.columnName + 'LABEL_', this.selectQuertersModels.selectList[0].label)
              vm.$set(vm.formData, e.columnName, this.selectQuertersModels.selectList[0].id)
              if (e.columnName.lastIndexOf('UID_') > -1) {
                let name = e.columnName.split('UID_')
                vm.$set(vm.formData, name[0] + 'NAME_', this.selectQuertersModels.selectList[0].label)
              }
              if (e.columnName.lastIndexOf('ID_') > -1) {
                let name = e.columnName.split('ID_')
                vm.$set(vm.formData, name[0] + 'NAME_', this.selectQuertersModels.selectList[0].label)
              }
            } else if (this.selectQuertersModels.form.widgetType === 'select-depart-multi') {
              // eslint-disable-next-line no-unused-vars
              var labels = ''; var ids = ''
              this.selectQuertersModels.selectList.forEach(element => {
                labels += element.label + ','
                ids += element.id + ','
              })
              vm.$set(vm.formData, e.columnName + 'LABEL_', labels.substring(0, labels.length - 1))
              vm.$set(vm.formData, e.columnName, ids.substring(0, ids.length - 1))

              if (e.columnName.lastIndexOf('UID_') > -1) {
                let name = e.columnName.split('UID_')
                vm.$set(vm.formData, name[0] + 'NAME_', labels.substring(0, labels.length - 1))
              }
              if (e.columnName.lastIndexOf('ID_') > -1) {
                let name = e.columnName.split('ID_')
                vm.$set(vm.formData, name[0] + 'NAME_', labels.substring(0, labels.length - 1))
              }
            }
          }
        })
      })
    },
    getParams () {
      return this.formData
    },
    queryData (flag) {
      console.log(this.formData, this.queryForm, 'this.formData')
      let params = {
        keyword: this.keyword,
        formData: this.formData
      }
      // eslint-disable-next-line eqeqeq
      if (flag != undefined && flag === 0) {
        this.$refs['queryForm'].resetFields()
        params = {
          keyword: '',
          formData: {}
        }
        this.keyword = ''
        this.formData = {}
        this.optionsBtnType = {}
      }
      this.$emit('queryData', params)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/form/query-form/mixin.js